import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClientWrapper } from './http-client-wrapper';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { ErrorContextService } from '../../shared/services/error-context/error-context.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private readonly _baseUrl: string;

  constructor(
    private readonly _http: HttpClient,
    private readonly _router: Router,
    private readonly _errorContext: ErrorContextService
  ) {
    this._baseUrl = environment.backendUrl;
  }

  createHttpClient(baseUrl?: string): HttpClientWrapper {
    baseUrl = baseUrl ?? this._baseUrl;
    return new HttpClientWrapper(baseUrl, this._http, this._router, this._errorContext);
  }
}
